module.exports = __webpack_public_path__ + "img/page_404_pin.192196fc.svg";